import React from "react";
import "../../../../styles/styles.css";
const Banner = () => {
  return (
    <div className="image-header-partner">
      <div className="header-text">
        <div>
          <span>Partner With Us for</span>
          <span>Fair,</span>
        </div>
        <div className="button-container">
        <span><span>Transparent</span> Deals</span>
          <button className="signup-zowo">
          Signup with Zowo
        </button>
        </div>
      </div>
    </div>
  );
};
export default Banner;
